import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import { darken } from 'polished';
export const List = ({ options, selectOption }) => (React.createElement(Container, null, options.map((option) => (React.createElement(ListItem, { key: option.value, onClick: () => selectOption(option) }, option.label)))));
const Container = styled.ul `
  padding: 0;
  margin: 0;
  max-height: 188px;
`;
const ListItem = styled.li `
  padding: 16px 24px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  font-size: 14px;
  cursor: pointer;
  color: ${theme.colors.liquorice};

  &:hover {
    background-color: ${darken(0.1, theme.colors.custard)};
  }

  &:last-child {
    border-bottom: none;
  }
`;
//# sourceMappingURL=List.js.map